'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linesForFontsize = undefined;

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var divideBy2 = (0, _ramda.flip)(_ramda.divide)(2);

var wholeLinesForFontSize = function wholeLinesForFontSize(minLeading, fontSize, baselineHeight) {
  var lines = Math.ceil(fontSize / baselineHeight);
  return lines * baselineHeight - fontSize >= minLeading ? lines : lines + 1;
};

// eslint-disable-next-line import/prefer-default-export
var linesForFontsize = exports.linesForFontsize = function linesForFontsize(minLeading, allowHalfLines, baselineHeight, fontSize) {
  return (0, _ramdaAdjunct.isTrue)(allowHalfLines) ? divideBy2(wholeLinesForFontSize(minLeading, fontSize, divideBy2(baselineHeight))) : wholeLinesForFontSize(minLeading, fontSize, baselineHeight);
};


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/baseline.js
// module id = 679
// module chunks = 168707334958949